<template>
  <div class="bg-image"></div>
  <div class="container">
    <img src="@/assets/logo.png" alt="Logo" class="logo"/>
    <div class="buttons">
      <a href="/ko/privacy_policy.html" class="text-button">개인정보처리방침</a>
      <a href="/ko/terms.html" class="text-button">이용약관</a>
      <a href="https://app.notion.com/p/3f8c3e34652d802787c1cb50f5385481" class="text-button" target="_blank" rel="noopener">확률형 아이템 정보</a>
    </div>
    <!-- Google Play & App Store 버튼 -->
    <div class="image-buttons">
      <a href="https://play.google.com/store/apps/details?id=com.basakansoft.jobmaker">
        <img src="@/assets/google_play_black.png" alt="Google Play"/>
      </a>
      <a href="https://apps.apple.com/kr/app/id6747634441">
        <img src="@/assets/app_store_black.png" alt="App Store"/>
      </a>
    </div>
    <!-- 사전예약 QR (데스크톱 전용) -->
    <div class="qr-section">
      <div class="qr-card">
        <img src="@/assets/preorder_qr.png" alt="사전예약 QR 코드" class="qr-code" decoding="async"/>
      </div>
      <p class="qr-caption">휴대폰으로 QR 코드를 스캔해 다운로드</p>
    </div>
    <div class="footer">
      <p>회사명 : 바삭한소프트 | 주소 : 서울시 성동구 왕십리로 222, 한양대학교 코맥스스타트업타운 1층 유니콘룸 | 사업자등록번호 : 306-09-10281 <br>
        통신판매업신고번호: 제 2024-서울성동-0973 호 | 문의 : contact@basakansoft.com</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeKr",
  mounted() {
    this.animateBounceInfinite();
  },
  methods: {
    animateBounceInfinite() {
      const logo = document.querySelector('.logo');
      const animate = () => {
        logo.classList.add('animate-bounce');
        setTimeout(() => {
          logo.classList.remove('animate-bounce');
        }, 2500);
      };
      animate();
      setInterval(animate, 5000);
    },
  }
};
</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';

body, html {
  margin: 0;
  padding: 0;
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('@/assets/wallpaper/wallpaper_main.png');
  filter: blur(12px);
  isolation: isolate;
}

.bg-image::after {
  content: '';
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(
      to right,
      rgba(255, 250, 233, 0.3) 0%,
      rgba(255, 250, 233, 0.8) 20%,
      rgba(255, 250, 233, 0.9) 50%,
      rgba(255, 250, 233, 0.8) 80%,
      rgba(255, 250, 233, 0.3) 100%
  );
}

@media (max-width: 800px) {
  .bg-image::after {
    background: linear-gradient(
        to right,
        rgba(255, 250, 233, 0.65) 0%,
        rgba(255, 250, 233, 0.8) 25%,
        rgba(255, 250, 233, 0.9) 50%,
        rgba(255, 250, 233, 0.8) 75%,
        rgba(255, 250, 233, 0.65) 100%
    );
  }
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  box-sizing: border-box;
  /* 하단 패딩으로 absolute footer 영역 확보 → 짧은(16:9) 화면에서 콘텐츠와 겹침 방지 */
  padding: 24px 16px 80px;
  position: relative;
}

.logo {
  margin-bottom: 20px;
  width: 280px;
}

.animate-bounce {
  animation: bounce 2s;
}


.text-button {
  margin: 5px;
  color: #4D2600;
  text-decoration: none;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  outline: none;
}

a {
  font-family: 'Roboto', sans-serif;
}

.buttons {
  margin-bottom: 20px; /* 버튼들과 이미지 버튼 사이의 여백 추가 */
}

.image-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.image-buttons a img {
  margin: 5px;
  width: 150px; /* 이미지 크기 조절 */
  cursor: pointer;
}

.qr-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.qr-card {
  background: #ffffff;
  padding: 12px;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(77, 38, 0, 0.18);
}

.qr-code {
  display: block;
  width: 150px;
  height: 150px;
  image-rendering: pixelated;
}

.qr-caption {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #4D2600;
  /* font-family 미지정 시 한글이 기본 serif(궁서/바탕)로 폴백되는 문제 방지 */
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Apple SD Gothic Neo', 'Malgun Gothic', 'Noto Sans KR', sans-serif;
}

/* 모바일은 자기 화면을 스캔할 수 없으므로 QR 숨김 */
@media (hover: none) and (pointer: coarse) {
  .qr-section { display: none; }
}

.footer {
  position: absolute;
  bottom: 15px;
  text-align: center;
  color: gray;
  font-size: 11.5px; /* You can adjust this value to make the text bigger or smaller */
  width: 100%;
  font-family: 'Roboto', sans-serif;
}

.company-logo {
  width: 110px;
}
</style>
